module.exports = __webpack_public_path__ + "img/Shaman-troll-m-60.47278039.gif";